export enum ModuleKey {
  Analyst,
  Library,
  Executive,
  AnalystHistorical
}